import labels from "emun.cust/_labels";

export default [
  { groupBy: 'Status' },
  { date: 'LastOrderedOn', title: 'Last Order Date' },
  { date: 'CreatedOn', title: 'Created Date', collapsed: true },
  //{groupBy:'City',maxHeight:200,collapsed:true},
  { groupBy: 'State', maxHeight: 200, collapsed: true },
  //{groupBy:'SalesRepName',title:'Rep',maxHeight:200,collapsed:true},
  { groupBy: 'AccountType', title: 'Account Type', maxHeight: 200, collapsed: true }
                //{groupBy:'TerritoryName',title:'Territory',maxHeight:200,collapsed:true},
                //{groupBy:'RegionName',title:'Region',maxHeight:200,collapsed:true}
];
